var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgConstructionMachineCraneLiftSvgrepo = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "construction-machine-crane-lift-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5 35V19.25H7.5V35H21.5ZM21.5 35H28.5M28.5 28L51.25 8.75M51.25 8.75L47.75 5.25L26.75 19.25H39L40.75 10.5M51.25 8.75V35C51.25 36.925 49.675 38.5 47.75 38.5C45.825 38.5 44.25 36.925 44.25 35V33.25H46M32 50.75H11C8.025 50.75 5.75 48.475 5.75 45.5C5.75 42.525 8.025 40.25 11 40.25H32C34.975 40.25 37.25 42.525 37.25 45.5C37.25 48.475 34.975 50.75 32 50.75ZM14.5 45.5C14.5 46.4665 13.7165 47.25 12.75 47.25C11.7835 47.25 11 46.4665 11 45.5C11 44.5335 11.7835 43.75 12.75 43.75C13.7165 43.75 14.5 44.5335 14.5 45.5ZM32 45.5C32 46.4665 31.2165 47.25 30.25 47.25C29.2835 47.25 28.5 46.4665 28.5 45.5C28.5 44.5335 29.2835 43.75 30.25 43.75C31.2165 43.75 32 44.5335 32 45.5ZM23.25 45.5C23.25 46.4665 22.4665 47.25 21.5 47.25C20.5335 47.25 19.75 46.4665 19.75 45.5C19.75 44.5335 20.5335 43.75 21.5 43.75C22.4665 43.75 23.25 44.5335 23.25 45.5Z",
    stroke: "#2153B1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgConstructionMachineCraneLiftSvgrepo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ConstructionMachineCraneLiftSvgrepo.18ecb902.svg";
export { ForwardRef as ReactComponent };